export default __webpack_public_path__ + "static/media/nixy_terms_conditions.0d02ed1f.docx";